import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/social/copy.svg")